import React, { useEffect, useState } from 'react'
import moment from 'moment'
import httpClient from 'utility/httpClient.util'

export const HOLD_BILL_DETAILS_PATH = '/clinical/patient-lock-edit/hold-bill'

export const getHoldBillDetailsUrl = (vn) =>
  HOLD_BILL_DETAILS_PATH + '?' + new URLSearchParams({ vn }).toString()

export const readHoldBillLocks = (response) => {
  const rows = response?.data?.data || response?.data
  if (response?.data?.actionStatus === false || !Array.isArray(rows)) {
    throw new Error('ตรวจสอบสถานะ Hold Bill ไม่สำเร็จ')
  }
  return rows
}

export const findActiveHoldBillLock = (locks = []) =>
  locks.find(
    (lock) => lock?.moduleName === 'HOLD_BILL' && Number(lock?.isLocked) === 1,
  ) || null

export const formatHoldBillDetails = (lock) => {
  const name = String(lock?.createdByName || '').trim()
  const userId = lock?.createdById
  const creator =
    name || (userId != null ? 'ผู้ใช้ #' + userId : 'ไม่พบข้อมูลผู้ Hold Bill')
  const createdAt = lock?.createdAt ? moment(lock.createdAt) : null
  const time = createdAt?.isValid()
    ? createdAt.format('DD/MM/') +
      (createdAt.year() + 543) +
      createdAt.format(' HH:mm')
    : ''

  return 'ผู้ Hold Bill: ' + creator + (time ? ' · ' + time + ' น.' : '')
}

// Metadata is display-only: a missing employee or failed lookup must never
// change the charge-editing lock held by the containing screen.
const HoldBillDetails = ({ vn, lock, refreshKey = '' }) => {
  const [result, setResult] = useState(null)

  useEffect(() => {
    if (lock !== undefined || !vn) return
    let active = true
    setResult(null)

    const load = async () => {
      try {
        const response = await httpClient.get(getHoldBillDetailsUrl(vn), {
          cache: false,
        })
        const rows = readHoldBillLocks(response)
        if (!active) return
        setResult({ vn, refreshKey, lock: findActiveHoldBillLock(rows) })
      } catch (error) {
        if (active) setResult({ vn, refreshKey, error: true })
      }
    }
    load()
    return () => {
      active = false
    }
  }, [vn, lock, refreshKey])

  const currentResult =
    result?.vn === vn && result?.refreshKey === refreshKey ? result : null
  const currentLock = lock !== undefined ? lock : currentResult?.lock
  let text = formatHoldBillDetails(currentLock)
  if (lock === undefined && vn && !currentResult)
    text = 'กำลังโหลดข้อมูลผู้ Hold Bill...'
  if (lock === undefined && currentResult?.error)
    text = 'ไม่สามารถโหลดข้อมูลผู้ Hold Bill ได้'

  return <small className="d-block">{text}</small>
}

export default HoldBillDetails
